import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { returnUrlFor } from './return-url';

export const authGuard: CanActivateFn = async (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (!auth.isAuthenticated()) {
    // Carry the address along, so signing in lands where the visitor was going.
    // Without it every shared link and every bookmark opens the home page for
    // anyone whose session has lapsed, which is indistinguishable from the link
    // being broken. Home needs no parameter — that is where sign-in goes anyway.
    const target = returnUrlFor(state?.url);
    if (target) {
      router.navigate(['/login'], { queryParams: { returnUrl: target } });
    } else {
      router.navigate(['/login']);
    }
    return false;
  }
  if (!auth.currentUser()) await auth.loadCurrentUser();
  return true;
};
